export default "__VITE_ASSET__Csu$8XqC__"